export const checkout_config = {
    checkoutCountryCode: process.env.NEXT_PUBLIC_CHECKOUT_COUNTRYCODE,
    checkoutBrand: process.env.NEXT_PUBLIC_BRAND,
    myAccountUrl: process.env.NEXT_PUBLIC_MY_ACCOUNT_URL,
};
